import { VStack } from 'tio-ui/components/layout';
import PageHero from 'tio-ui/components/page-hero';
import { PhCompass } from 'ember-phosphor-icons';
import t from 'ember-intl/helpers/t';

<template>
  <VStack class="gap-8 pb-12">
    <PageHero
      @icon={{PhCompass}}
      @title={{t "strategy_finder_0726.title"}}
      @subtitle={{t "strategy_finder_0726.subtitle"}}
      @gradient="brand"
      @decoration="circles"
    />
    {{outlet}}
  </VStack>
</template>
